import { combineReducers } from "redux";
import { forgotApiReducer, loginApiReducer, resetPasswordApiReducer, signUpApiReducer } from "./Auth";
import { addDepartmentReducer, appliedTenderDocumentReducer, applyForTenderReducer, assignedTenderStatusReducer, changeDepartmentApiReducer, changePasswordReducer, dashboardGetReducer, deleteTenderApiReducer, editProfileReducer, getAllTendersCompaniesReducer, getAllTendersReducer, getAppliedTendersReducer, getAssignedTendersReducer, getDepartmentsReducer,
    getInterestedTendersReducer,
    getIntrestedTenderCompaniesDropdownReducer,
    getIntrestedTenderCompaniesReducer,
    getProfileReducer,
    getTendersResultsReducer,
    interestedTenderDocumentsReducer,
    selectDepartmentReducer,
    selectedTotalDepartmentsReducer,
    uploadTenderResultsReducer,
    userCompaniesFilterReducer
} from "./Dashboard";
import { addAssigneeApiReducer, addCommentApiReducer, addDocumentApiReducer, applyTenderApiReducer, deleteDocumentApiReducer, getAssigneesApiReducer, getAttachmentsApiReducer, getDepartmentUserApiReducer } from "./InterestedTender";

const rootReducer = combineReducers({

    auth: loginApiReducer,
    signUpAuth: signUpApiReducer,
    forgotAuth: forgotApiReducer,
    resetAuth: resetPasswordApiReducer,

    getEditProfile: editProfileReducer,
    getUserProfile: getProfileReducer,
    getChangePassword: changePasswordReducer,

    getUserOfDepartments: getDepartmentUserApiReducer,

    getDashboard: dashboardGetReducer,
    companiesAllTendersGetData: getAllTendersCompaniesReducer,
    interestedTenderCompaniesData: getIntrestedTenderCompaniesReducer,
    interestedTenderCompaniesDropdownData: getIntrestedTenderCompaniesDropdownReducer,
    getAllTendersData: getAllTendersReducer,
    getCompaniesFilterData: userCompaniesFilterReducer,
    departmentsGet: getDepartmentsReducer,
    departmentAdd: addDepartmentReducer,
    departmentSelect: selectDepartmentReducer,
    selectedTendersDepartments: selectedTotalDepartmentsReducer,
    assignedTendersGet: getAssignedTendersReducer,
    selectAssignedTenders: assignedTenderStatusReducer,
    interestedTendersGet: getInterestedTendersReducer,
    documentInterestedTender: interestedTenderDocumentsReducer,
    appliedTendersData: getAppliedTendersReducer,
    appliedTenderDocumentData: appliedTenderDocumentReducer,
    getApplyTenderData: applyForTenderReducer,
    getTendersResultsData: getTendersResultsReducer,
    getUploadtendersResults: uploadTenderResultsReducer,


    getAddAssignee: addAssigneeApiReducer,
    getAssignees: getAssigneesApiReducer,
    getAddComments: addCommentApiReducer,
    getAddDocuments: addDocumentApiReducer,
    getAttachments: getAttachmentsApiReducer,
    getInterestedTenderApplied: applyTenderApiReducer,

    getDeletedDocument: deleteDocumentApiReducer,
    getChangeDepartment: changeDepartmentApiReducer,
    getDeletedTender: deleteTenderApiReducer

})

export default rootReducer;